import { render, staticRenderFns } from "./VerifyBelts.vue?vue&type=template&id=4fb896a2&scoped=true"
import script from "./VerifyBelts.vue?vue&type=script&lang=js"
export * from "./VerifyBelts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb896a2",
  null
  
)

export default component.exports